import * as ol from 'openlayers';

export function createRectangle(coordinates, strokeColor: string= 'transparent',
fillColor: string= 'transparent',
): ol.layer.Vector {
  let polygon = null;
  let polygonFeature = null;
  let layer = null;
  const minPixel = coordinates.pointmaxs;
  const maxPixel = coordinates.pointmins;
  const style = new ol.style.Style({
    stroke: new ol.style.Stroke({
      width: 1,
      color: strokeColor
    }),
    fill: new ol.style.Fill({
      color: fillColor
    })
  });

  if (!layer) {
    layer = new ol.layer.Vector({
      source: new ol.source.Vector(),
      style: style
    });
  }
  if (!polygon) {
    polygon = new ol.geom.Polygon();
    polygon.setCoordinates([[minPixel, [maxPixel[0], minPixel[1]], maxPixel, [minPixel[0], maxPixel[1]], minPixel]]);
  }

  if (!polygonFeature) {
    polygonFeature = new ol.Feature(polygon);
    layer.getSource().addFeature(polygonFeature);
  }
  return layer;
}

export function getCoordinates(pointArr: Array<number>): Array<Array<Array<number>>> {
  const arr = new Array();
  for (let i = 0; i < pointArr.length; i += 2) {
    arr.push([pointArr[i], pointArr[i + 1]]);
  }
  return [arr];
}
